import React, { useEffect, useState } from 'react';
import './App.css';

import Header from './components/Header/Header';
import HeroSection from './components/Hero/HeroSection';
import ServicesSection from './components/Services/ServicesSection';
import ContactSection from './components/Contact/ContactSection';
import FAQSection from './components/FAQ/FAQSection';
import Footer from './components/Footer/Footer';
import InstagramGallery from "./components/InstagramGallery/InstagramGallery";
import AboutSection from "./components/About/AboutSection";

function App() {
    const [darkMode, setDarkMode] = useState(false);

    useEffect(() => {
        const savedMode = localStorage.getItem("dark-mode");
        if (savedMode === "enabled") {
            document.body.classList.add("dark-mode");
            setDarkMode(true);
        }
    }, []);

    const toggleDarkMode = () => {
        if (darkMode) {
            document.body.classList.remove("dark-mode");
            localStorage.setItem("dark-mode", "disabled");
        } else {
            document.body.classList.add("dark-mode");
            localStorage.setItem("dark-mode", "enabled");
        }
        setDarkMode(!darkMode);
    };

    return (
        <div className={`app ${darkMode ? "dark-mode" : ""}`}>
            <Header toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
            <HeroSection />
            <AboutSection />
            <ServicesSection />
            <FAQSection />
            <InstagramGallery />
            <ContactSection />
            <Footer />
        </div>
    );
}

export default App;
